import * as React from 'react';
import { Api } from './@context/Api';

import { createStyles, makeStyles } from '@material-ui/styles';
import 'minireset.css';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { polyfill } from 'smoothscroll-polyfill';
import { ResponsiveProvider } from './@context/Responsive';
import ArrowLink from './Assets/link-arrow.svg';
import Menu from './Components/Menu';
import Pages from './Components/Pages';
import Splash from './Components/Splash';
import fonts from './constants/fonts';
import mediaQueries from './constants/responsive';
import spacing from './constants/spacing';
import stylesheet, { bodyFontSize, mainColor, secondaryColor } from './constants/stylesheet';

export type App = AppDto;

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      'html, body': {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        ...stylesheet.Body
      },
      'a': {
        textDecoration: 'none',
        color: mainColor,
        cursor: 'pointer',
        "&:hover": {
          color: secondaryColor,
        }
      },
      '#root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        top: 0,
        left: 0,
        background: 'white'
      },
      'p a': {
        backgroundImage: `linear-gradient(to bottom,rgba(0,0,0,0) 50%,${mainColor} 50%)`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: '2px 2px',
        backgroundPosition: '0 .9em',

        '&:hover': {
          backgroundImage: `linear-gradient(to bottom,rgba(0,0,0,0) 50%,${secondaryColor} 50%)`,
        },
      },
      'em': {
        ...fonts.NeueHaasGroteskNormalItalic,
      },
      'strong':{
        ...fonts.NeueHaasGroteskBold
      },
      'em strong': {
        ...fonts.NeueHaasGroteskBoldItalic
      },
      '.custom-style-title': {
        ...stylesheet.MainTitle
      },
      '.custom-style-subtitle': {
        ...fonts.NeueHaasGroteskBold,
        lineHeight: '1.2',
        [mediaQueries.Mobile]: {
          fontSize: `${18 / bodyFontSize.Mobile}rem`,
          marginBottom: `${5 / bodyFontSize.Mobile}rem`,
        },
        [mediaQueries.Tablet]: {
          fontSize: `${20 / bodyFontSize.Tablet}rem`,
          marginBottom: `${10 / bodyFontSize.Tablet}rem`,
        },
        [mediaQueries.Laptop]: {
          fontSize: `${20 / bodyFontSize.Laptop}rem`,
          marginBottom: `${10 / bodyFontSize.Laptop}rem`,
        },
        [mediaQueries.Desktop]: {
          fontSize: `${20 / bodyFontSize.Desktop}rem`,
          marginBottom: `${10 / bodyFontSize.Desktop}rem`,
        },
        [mediaQueries.BigDesktop]: {
          fontSize: `${24 / bodyFontSize.BigDesktop}rem`,
          marginBottom: `${15 / bodyFontSize.BigDesktop}rem`,
        }
      },
      '.custom-style-gray-link a': {
        ...stylesheet.BoldText,
        color: secondaryColor,
        display: 'inline-block',
        cursor: 'pointer',
        marginTop: 8,
        background: 'none',

        '&:hover': {
          background: 'none',
          color: mainColor
        },
      },
      '.custom-style-arrow-link a': {
        ...stylesheet.BoldText,
        color: secondaryColor,
        display: 'inline-block',
        marginTop: 8,
        cursor: 'pointer',
        position: 'relative',
        paddingRight: 8,
        background: 'none',

        '&:hover': {
          background: 'none',
          color: mainColor,

        },

        '&:after': {
          content: `url(${ArrowLink})`,
          width: 10,
          height: 10,
          position: 'absolute',
          top: '-1px',
          right: 0,
        },

        '&:hover:after': {
          filter: 'brightness(0%)'
        }
      },
      '.custom-style-introduction': {
        ...stylesheet.Introduction,
      },
      // '.custom-style-indent-years': {
      //   position: 'relative',
      //   display: 'block',
      //   paddingLeft: 50,
      // },
      // '.custom-style-indent-date': {
      //   position: 'absolute',
      //   top: 0,
      //   left: 0,
      // },
    },
    app: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: '1rem',
      zIndex: 0
    },
    content: {
      position: 'relative',
      boxSizing: 'border-box',

      '[data-type="Artists"] &': {
        paddingTop: 0
      },

      '[data-type="Fairs"] &': {
        paddingTop: 0
      },

      '[data-type="Exhibitions"] &': {
        paddingTop: 0
      },

      [mediaQueries.Mobile]: {
        paddingTop: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingTop: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingTop: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingTop: spacing.Gutter.Desktop,
      },
      [mediaQueries.BigDesktop]: {
        paddingTop: spacing.Gutter.BigDesktop * 2,
      },
    },
  }));

// smoothscroll polyfill!
polyfill();

const App: React.FC = () => {
  const cls = useStyles();
  const [showIntro, setShowIntro] = useState(false);

  React.useEffect(() => {
    const sessionShowIntro = sessionStorage.getItem("showIntro");

    if (sessionShowIntro === null || sessionShowIntro === "true") {
        sessionStorage.setItem("showIntro", "false");
        setShowIntro(true);
    } else {
      setShowIntro(false);
    }
  }, [])

  return (
    <Router>
      <Api>
        {showIntro && <Splash/>}
        <ResponsiveProvider mediaQueries={mediaQueries} >
          <div className={cls.app} id={"scrollContainer"}>
            <Menu />
            <div className={cls.content}>
              <Switch>
                {
                  // tslint:disable-next-line:jsx-no-lambda
                  <Route render={() => <Pages />} />
                }
              </Switch>
            </div>
          </div>
        </ResponsiveProvider>
      </Api>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx